export default "__VITE_PUBLIC_ASSET__9e8503b8__"